import type { ISocialAccount } from '@components';
import type { PostPerformanceData } from '@/applications/Social/creator-search/instagram/components/post-performance-section/hooks';

export const memberPostPerformanceAdapter = (
  socialData: ISocialAccount,
): PostPerformanceData => {
  // Avg. Impressions per Post
  const avgImpressionsPerPost = socialData.impressions !== undefined && socialData.impressions !== null
    ? Math.round(socialData.impressions).toLocaleString()
    : '--';

  // Post Impression Ratio (formatted as X:1)
  const postImpressionRatio = socialData.impressions_ratio !== undefined && socialData.impressions_ratio !== null
    ? `${Math.round(socialData.impressions_ratio).toLocaleString()}:1`
    : '--';

  // Stories Impression Ratio (as percentage)
  const storiesImpressionRatio = socialData.stories_impressions_ratio !== undefined && socialData.stories_impressions_ratio !== null
    ? `${Math.round(socialData.stories_impressions_ratio)}%`
    : '--';

  // Comment Sentiment (mapped from score to text)
  let commentSentiment = '--';
  if (socialData.report?.comment_sentiment?.score !== undefined && socialData.report?.comment_sentiment?.score !== null) {
    const score = socialData.report.comment_sentiment.score;
    if (score > 0.6) {
      commentSentiment = 'Very Positive';
    } else if (score > 0.2) {
      commentSentiment = 'Mostly Positive';
    } else if (score > -0.2) {
      commentSentiment = 'Neutral';
    } else {
      commentSentiment = 'Negative';
    }
  }

  // Avg. Saves per Post
  const avgSavesPerPost = socialData.saves !== undefined && socialData.saves !== null
    ? Math.round(socialData.saves).toLocaleString()
    : '--';

  // Likes per Post
  const likesPerPost = socialData.likes !== undefined && socialData.likes !== null
    ? Math.round(socialData.likes).toLocaleString()
    : '--';

  // Avg. Comments per Post
  const avgCommentsPerPost = socialData.average_comments_count !== undefined && socialData.average_comments_count !== null
    ? Math.round(socialData.average_comments_count).toLocaleString()
    : '--';

  // Likes to Comments Ratio (formatted as X:1)
  const likesToCommentsRatio = socialData.likes_comments_ratio !== undefined && socialData.likes_comments_ratio !== null
    ? `${(socialData.likes_comments_ratio / 100).toFixed(2)}:1`
    : '--';

  return {
    avgImpressionsPerPost,
    postImpressionRatio,
    storiesImpressionRatio,
    commentSentiment,
    avgSavesPerPost,
    likesPerPost,
    avgCommentsPerPost,
    likesToCommentsRatio
  };
};
